import styled from "styled-components";

export const Link = styled.a`
  display: block;
  padding: 20px;
`;

export const Icon = styled.img`
  display: block;
`;
